import { gridSize } from "../config";
export function makePossibleCoordinate(candidateCoordinate) {
    if (candidateCoordinate >= 1 && candidateCoordinate <= gridSize) {
        return candidateCoordinate;
    }
    else {
        throw new Error("The coordinate is not a valid coordinate");
    }
}
export const possibleDirection = ["Up", "Down", "Right", "Left"];
export function makePossibleVectorValue(candidateVectorValue) {
    if (candidateVectorValue >= -1 && candidateVectorValue <= 1) {
        return candidateVectorValue;
    }
    else {
        throw new Error("This is not a valid direction vector value");
    }
}
export const possibleDirectionVector = [
    {
        x: makePossibleVectorValue(0),
        y: makePossibleVectorValue(-1)
    },
    {
        x: makePossibleVectorValue(0),
        y: makePossibleVectorValue(1)
    },
    {
        x: makePossibleVectorValue(1),
        y: makePossibleVectorValue(0)
    },
    {
        x: makePossibleVectorValue(-1),
        y: makePossibleVectorValue(0)
    },
];
const possibleBindingListOperation = ["remove", "add"];
const edgeCoordinateCornerList = ["above-radius", "bottom-radius", "left-radius", "right-radius"];
const possibleGameState = [
    "startPage",
    "playing"
];
